import PropTypes from 'prop-types';

const TextareaField = ({
  input,
  disabled,
  label,
  labelRequired,
  placeholder,
  meta: { touched, error, warning, submitError },
  helpText,
  cssClass,
}) => {
  const { name, ...inputProps } = input;

  if (!error) {
    error = submitError;
  }

  return (
    <div className={`form-group textarea${cssClass ? ' ' + cssClass : ''}${touched && error ? ' error' : ''}`}>
      {label && (
        <label htmlFor={name}>
          {label}
          {labelRequired && <abbr title="Required">*</abbr>}
        </label>
      )}
      <textarea {...inputProps} id={name} placeholder={placeholder} className="form-control" disabled={disabled}></textarea>
      {helpText && <div className="text-info">{helpText}</div>}
      {touched && error && <div className="text-danger">{error}</div>}
      {touched && warning && !error && <div className="text-warning">{warning}</div>}
    </div>
  );
};

TextareaField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  meta: PropTypes.object,
  helpText: PropTypes.string,
  cssClass: PropTypes.string,
};

export default TextareaField;
